import { render, staticRenderFns } from "./linkingActivity.vue?vue&type=template&id=3d766516&scoped=true&"
import script from "./linkingActivity.vue?vue&type=script&lang=js&"
export * from "./linkingActivity.vue?vue&type=script&lang=js&"
import style0 from "./linkingActivity.vue?vue&type=style&index=0&id=3d766516&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d766516",
  null
  
)

export default component.exports